import { FC } from 'react'

import { useTranslation } from 'react-i18next'

import { AppIcon } from 'shared/ui/app-icon'
import { AllIcons } from 'shared/ui/app-icon/types'

import s from './styles.module.scss'

interface Props {
  onClick?: () => void
}

export const AppealInfoButton: FC<Props> = ({ onClick }) => {
  const { t } = useTranslation()

  return (
    <div
      onClick={onClick}
      className={s.container}
    >
      <p>{t('app_info')}</p>
      <AppIcon id={AllIcons.ARROW_RIGHT} />
    </div>
  )
}
